const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const ENV_API_WS_TASKS_URL = process.env.REACT_APP_API_WS_TASKS_URL;
const ENV_API_FLOWER_BASE_URL = process.env.REACT_APP_API_FLOWER_BASE_URL;

export const API_BASE_URL = `${ENV_API_BASE_URL ? ENV_API_BASE_URL.replace(/\/$/, '') : 'http://localhost:8000'}/`;
export const API_FLOWER_BASE_URL = `${ENV_API_FLOWER_BASE_URL ? ENV_API_FLOWER_BASE_URL.replace(/\/$/, '') : 'http://localhost:8001/api'}/`;
export const API_WS_TASKS_URL = `${ENV_API_WS_TASKS_URL ? ENV_API_WS_TASKS_URL.replace(/\/$/, '') : 'wss://beta.linkimpactreport.com/api/flower/task/events'}/`;
